import React from 'react';
import { motion } from 'framer-motion';
import Marquee from 'react-fast-marquee';

const TechStack = () => {
  const techLogos = {
    ai: [
      { name: 'Claude', abbr: 'CL' },
      { name: 'GPT-4', abbr: 'GPT' },
      { name: 'OpenClaw', abbr: 'OC' },
      { name: 'Gemini', abbr: 'GE' },
    ],
    development: [
      { name: 'Next.js', abbr: 'NX' },
      { name: 'React', abbr: 'RE' },
      { name: 'Supabase', abbr: 'SB' },
      { name: 'Vercel', abbr: 'VE' },
    ],
    automation: [
      { name: 'Make.com', abbr: 'MK' },
      { name: 'Zapier', abbr: 'ZP' },
      { name: 'n8n', abbr: 'N8' },
    ],
    design: [
      { name: 'Figma', abbr: 'FG' },
      { name: 'v0.dev', abbr: 'V0' },
      { name: 'Midjourney', abbr: 'MJ' },
    ],
    voice: [
      { name: 'ElevenLabs', abbr: '11' },
      { name: 'Whisper', abbr: 'WH' },
      { name: 'AssemblyAI', abbr: 'AA' },
    ],
  };

  const allTech = [
    ...techLogos.ai,
    ...techLogos.development,
    ...techLogos.automation,
    ...techLogos.design,
    ...techLogos.voice,
  ];

  const TechBadge = ({ name, abbr }) => (
    <div className="flex items-center gap-3 px-4 py-3 mx-3 bg-white rounded-xl border border-slate-100 shadow-sm hover:shadow-md hover:border-[#00e5ff]/30 transition-all duration-300 cursor-default group">
      <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-slate-100 to-slate-50 flex items-center justify-center font-bold text-sm text-[#1a237e] group-hover:from-[#00e5ff]/20 group-hover:to-[#1a237e]/10 transition-colors">
        {abbr}
      </div>
      <span className="text-[#5a6b8c] font-medium whitespace-nowrap">{name}</span>
    </div>
  );

  return (
    <section className="section-padding bg-white overflow-hidden" data-testid="tech-stack-section">
      <div className="section-container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <span className="text-sm font-medium tracking-wide uppercase text-[#00e5ff] mb-3 block">
            Technology
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#212121] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="tech-stack-headline"
          >
            Built With Modern Tools
          </h2>
          <p className="text-base md:text-lg text-[#5a6b8c] max-w-2xl mx-auto">
            We use the best AI and development tools in 2026
          </p>
        </motion.div>
      </div>

      {/* Marquee Section */}
      <div className="marquee-wrapper">
        <Marquee
          speed={40}
          gradient={false}
          className="py-4"
        >
          {allTech.map((tech, index) => (
            <TechBadge key={`row1-${index}`} name={tech.name} abbr={tech.abbr} />
          ))}
        </Marquee>
        <Marquee
          speed={40}
          gradient={false}
          direction="right"
          className="py-4"
        >
          {[...allTech].reverse().map((tech, index) => (
            <TechBadge key={`row2-${index}`} name={tech.name} abbr={tech.abbr} />
          ))}
        </Marquee>
      </div>

      {/* Categories Legend */}
      <div className="section-container mt-8">
        <div className="flex flex-wrap justify-center gap-4 md:gap-6">
          {[
            { label: 'AI', color: 'bg-purple-100 text-purple-700' },
            { label: 'Development', color: 'bg-blue-100 text-blue-700' },
            { label: 'Automation', color: 'bg-green-100 text-green-700' },
            { label: 'Design', color: 'bg-pink-100 text-pink-700' },
            { label: 'Voice', color: 'bg-amber-100 text-amber-700' },
          ].map((cat, i) => (
            <span
              key={i}
              className={`px-3 py-1 rounded-full text-xs font-medium ${cat.color}`}
            >
              {cat.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
